import envVariables from "../lib/envHelpers/getEnvVariables";
import deepMerge from "../lib/DeepMerge";
import { applyLanApiHost, HOST_LAN_IP_ENV } from "./lanApiHost";
import * as configs from "./modules/";

let config = configs["default"];

const vendor = envVariables.CONFIG_VENDOR_KEY || envVariables.VENDOR;
const generalConfigKey = `${vendor}_default`;
const specificConfigKey =
  envVariables.CONFIG_ENV_KEY ||
  `${vendor}_${envVariables.TARGET_ENV || envVariables.NODE_ENV}`;

let vendorConfig = deepMerge(
  configs[generalConfigKey],
  configs[specificConfigKey]
);

// `squaber_development.js` is gitignored and absent from CI builds; avoid a dead env key.
if (!configs[specificConfigKey] && vendor === "squaber" && specificConfigKey.endsWith("_development")) {
  const stagingFallbackKey = `${vendor}_staging`;
  if (configs[stagingFallbackKey]) {
    vendorConfig = deepMerge(configs[generalConfigKey], configs[stagingFallbackKey]);
  }
}

config = deepMerge(config, vendorConfig);

const isLocalApi =
  envVariables.TARGET_ENV === "local" || specificConfigKey.endsWith("_local");

if (isLocalApi && envVariables[HOST_LAN_IP_ENV]) {
  config = applyLanApiHost(config, envVariables[HOST_LAN_IP_ENV]);
}

export default config;
